import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_IsIndependent.scss'
import { Row, Col, Modal, Button } from 'react-bootstrap'
import close from './close.svg'

class IsIndependent extends React.Component {
  static propTypes = {
    isIndependent: PropTypes.bool,
    className: PropTypes.string,
    conflictDeclarations: PropTypes.array,
    placement: PropTypes.string
  }

  constructor (props) {
    super(props)
    this.state = {
      showPopover: false,
      mobilePopoverShow: false,
      mobilePopoverHide: true,
      mobilePopover: false
    }
    this.showHidePopover = this.showHidePopover.bind(this)
    this.hideMobileModal = this.hideMobileModal.bind(this)
    this.showMobileModal = this.showMobileModal.bind(this)
  }

  showHidePopover () {
    this.setState({ showPopover: !this.state.showPopover })
  }

  clickShowPopover () {
    this.setState({ clickShowPopover: !this.state.clickShowPopover })
  }

  clickHidePopover () {
    this.setState({ clickShowPopover: false })
  }

  hideMobileModal (event) {
    this.setState({ mobileModal: false })
    if (event) {
      event.preventDefault()
    }
  }

  showMobileModal (event) {
    this.setState({ mobileModal: true })
  }

  render () {
    const { isIndependent, conflictDeclarations } = this.props
    const independentText = 'No conflict of interest'
    const notIndependentText = 'Potential conflict of interest'
    const independanceMessage = isIndependent ? independentText : notIndependentText
    let className = this.props.className
    if (!className) { className = styles['independence-desktop'] }

    const liClass = styles['no-dot'] + ' ' + styles['independant-li-fontsize']
    const popoverBody = (<div className={styles['popover-body']} onClick={this.hidePopover}>
      <Row>
        {!isIndependent && <ul>
          {conflictDeclarations && conflictDeclarations.map((element, index) => {
            return <li style={{fontSize: '1.6rem', fontWeight: 300}} className={liClass} key={index}>{element.description}</li>
          })}
        </ul>}
        {isIndependent && <ul><li style={{fontSize: '16px', fontWeight: 300}} className={styles['no-dot']}>This adviser has no conflict of interest in the advice they give or the financial products or services that they recommend</li></ul>}
      </Row>
    </div>)

    const independElement = <Row style={{cursor: 'pointer'}} onClick={this.showMobileModal}>
      <Col xs={12} sm={12} md={12} lg={12}>
        <Button style={{textAlign: 'left', background: 'transparent'}} onClick={() => { this.showMobileModal() }} className={styles['conflict-button']}>
          <span className={styles['independence-message']}>
            {independanceMessage}
          </span>
        </Button>
      </Col>
    </Row>

    let mobilePopoverStyle
    if (this.state.mobilePopover) {
      mobilePopoverStyle = styles['show-mobile-popover']
    } else {
      mobilePopoverStyle = styles['mobile-popover']
    }

    return <Row>
      <Col className="d-none d-md-block" sm={12} md={12} lg={12}>
        <div style={{cursor: 'pointer'}}
          onClick={this.showMobileModal}
          className={styles['mobile-overlay-container'] + ' ' + styles['padding-bottom-10']}>
          {independElement}
          <div className={styles['overlay-base'] + ' ' + mobilePopoverStyle}>
            {popoverBody}
          </div>
        </div>
      </Col>
      <Col xs={12} className="d-block d-md-none">
        <div style={{cursor: 'pointer'}}
          onClick={this.showMobileModal}
          className={styles['mobile-overlay-container']}>
          {independElement}
          <div className={styles['overlay-base'] + ' ' + mobilePopoverStyle}>
            {popoverBody}
          </div>
        </div>
      </Col>

      <Modal show={this.state.mobileModal || this.state.showPopover || this.state.clickShowPopover} className={styles['mobile-modal']}>
        <Modal.Body onClick={this.hideMobileModal}>
          <a onClick={(event) => this.hideMobileModal(event)} href='#' className={styles['close-anchor']}>
            <img src={close} height={25} width={25} />
          </a>
          { !isIndependent && <ul style={{marginTop: '10px'}}>
            {conflictDeclarations && conflictDeclarations.map((element, index) => {
              return <li className={liClass} key={index}>{element.description}</li>
            })}
          </ul> }
          {isIndependent && <ul className={styles['ul-padding']} ><li className={styles['no-dot']}>This adviser has no conflict of interest in the advice they give or the financial products or services that they recommend</li></ul>}
        </Modal.Body>
      </Modal>
    </Row>
  }
}

export default (IsIndependent)
